import React, { useEffect, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

/* import element from component folder */
import Table from '../../table';
import TableList from "../../../components/tableList";

/* import config from json folder */
import tableHeader from "../../../assecs/json/table/business/applying.json"; 

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import fetch function */
import { FetchApplyingSource, MemberMultipleReview } from "../../../services/business";

const MemberAgree = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState({});
    const [tableBody, setTable] = useState(null); 
    
    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value }}) => {
        delete error[name];
        
        source[name] = value;
        
        setError(error);
        setSource(source);
    };

    const submitHandler = event => {
        event.preventDefault();
        const isAgree = event.target.name === 'agree' ? true : false;
        const isValidate = isAgree || validate();
        
        source.isAgree = isAgree;
        
        if (isValidate) {
            MemberMultipleReview(source).then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                    dispatch(setAction());
                }
            });
        }
    };

    const validate = () => {
        const checkLists = ['rejectReason'];
        const _errors = {};

        checkLists.map( list => (
            (!source[list]) && ( _errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    const tableLists = data => {
        const lists = [];
        
        data.map((value, index) => 
            lists.push(<TableList key={ value.mId } index={ index } targets={ tableHeader } content={ value } id={ value.mId } />)
        );

        setTable(lists);
    };

    useEffect(() => {
        FetchApplyingSource().then(response => {
            tableLists(response);
        })
    }, [])

    return (
        <Modal show={ true } size="lg" centered>
            <Modal.Header>Review Member</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <Table header={ tableHeader } body={ tableBody } selectHandler={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Reject Reason</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='rejectReason' placeholder='please enter the reason when you reject.' is-required={`${error.rejectReason}`} onChange={ changHandler } />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" name="reject" variant="danger" data-shadow onClick={ submitHandler }>Reject</Button>
                        <Button type="button" name="agree" data-shadow onClick={ submitHandler }>Agree</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default MemberAgree;